import React from 'react';
import styles from './Button.module.css';

/**
 * Универсальный компонент кнопки
 * @param {string} text - Текст кнопки
 * @param {function} onClick - Функция обработчик клика
 * @param {string} className - Дополнительные CSS классы
 * @param {string} type - Тип кнопки (primary, secondary и т.д.)
 * @param {object} props - Дополнительные свойства
 */
const Button = ({ 
  text, 
  onClick, 
  className = '', 
  type = 'primary',
  ...props 
}) => {
  console.log('Отрисовка компонента Button с текстом:', text);
  
  return (
    <button 
      className={`${styles.button} ${styles[type]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {text}
    </button>
  );
};

export default Button; 